import React from "react";
import CelebrationButton from "../ui/CelebrationButton/CelebrationButton";

function ComplianceCertificationSection({
  complianceData,
  CompliancehandleChange,
  CompliancehandleSubmit,
  isAnimate,
}) {
  return (
    <>
      <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
        {/* Header */}
        <div className="p-4 border-b border-slate-200 dark:border-slate-800 text-center">
          <span className="text-red-600 font-semibold underline text-sm">
            (PCC) PACIFIC COAST CONTAINER ( Compliance / Certification )
          </span>
        </div>

        {/* Body */}
        <div className="p-6">
          <div className="container-fluid">
            {/* ===== SALES AGREEMENT ===== */}
            <div className="rounded-md border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 mb-4">
              <div className="flex gap-2 px-4 py-2 border-b border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
                <div className="font-semibold text-slate-700 dark:text-slate-200">
                  (a)
                </div>
                <div className="text-slate-700 dark:text-slate-200">
                  Sales Agreement –{" "}
                  <span className="font-semibold text-slate-900 dark:text-slate-100">
                    Design System for 24 month renewal cycle. Tie to A/P to
                    prevent payments for commission without agreement on file.
                  </span>
                </div>
              </div>

              {/* Required */}
              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-2 border-b border-slate-200 dark:border-slate-700">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (i)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.sales_Required}
                    onChange={(e) =>
                      CompliancehandleChange("sales_Required", e.target.checked)
                    }
                  />
                  Required
                </label>
              </div>

              {/* Date */}
              <div className="grid grid-cols-1 md:grid-cols-[40px_160px_1fr] gap-2 px-4 py-2 border-b border-slate-200 dark:border-slate-700">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (ii)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.sales_Agree_Date_chk}
                    onChange={(e) =>
                      CompliancehandleChange(
                        "sales_Agree_Date_chk",
                        e.target.checked,
                      )
                    }
                  />
                  Date
                </label>
                <input
                  type="date"
                  className="w-32 rounded border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-sm px-2 py-1 focus:outline-none focus:ring-1 focus:ring-green-600"
                  value={complianceData.sales_Agreement_date}
                  onChange={(e) =>
                    CompliancehandleChange(
                      "sales_Agreement_date",
                      e.target.value,
                    )
                  }
                />
              </div>

              {/* Attached */}
              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-2">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (iii)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.sales_Attach}
                    onChange={(e) =>
                      CompliancehandleChange("sales_Attach", e.target.checked)
                    }
                  />
                  Attached Agreement
                </label>
              </div>
            </div>

            {/* ===== FORWARDERS LICENSE ===== */}
            <div className="rounded-md border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 mb-4">
              <div className="flex gap-2 px-4 py-2 border-b border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
                <div className="font-semibold text-slate-700 dark:text-slate-200">
                  (b)
                </div>
                <div className="text-slate-700 dark:text-slate-200">
                  Forwarders License # –{" "}
                  <span className="font-semibold text-slate-900 dark:text-slate-100">
                    Design System for 24 month renewal cycle. Tie to A/P to
                    prevent brokerage payment without License # & Verification
                    on file.
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_160px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (i)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.forwarder_Licn_Confirmed}
                    onChange={(e) =>
                      CompliancehandleChange(
                        "forwarder_Licn_Confirmed",
                        e.target.checked,
                      )
                    }
                  />
                  Date Confirmed
                </label>
                <input
                  type="date"
                  className="w-32 rounded border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-sm px-2 py-1 focus:outline-none focus:ring-1 focus:ring-green-600"
                  value={complianceData.forwarder_Licn_ConfirmDate}
                  onChange={(e) =>
                    CompliancehandleChange(
                      "forwarder_Licn_ConfirmDate",
                      e.target.value,
                    )
                  }
                />
              </div>
            </div>

            {/* ===== VALID POA ON-FILE ===== */}
            <div className="rounded-md border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 mb-4">
              <div className="flex gap-2 px-4 py-2 border-b border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
                <div className="font-semibold text-slate-700 dark:text-slate-200">
                  (c)
                </div>
                <div className="text-slate-700 dark:text-slate-200 font-semibold">
                  Valid POA On-File
                </div>
              </div>

              {/* Expiry Date */}
              <div className="grid grid-cols-1 md:grid-cols-[40px_160px_1fr] gap-2 px-4 py-3 border-b border-slate-200 dark:border-slate-700">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (i)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.poaexpiry}
                    onChange={(e) =>
                      CompliancehandleChange("poaexpiry", e.target.checked)
                    }
                  />
                  Expiry Date
                </label>
                <input
                  type="date"
                  className="w-32 rounded border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-sm px-2 py-1 focus:outline-none focus:ring-1 focus:ring-green-600"
                  value={complianceData.poaexpirydate}
                  onChange={(e) =>
                    CompliancehandleChange("poaexpirydate", e.target.value)
                  }
                />
              </div>

              {/* Attached */}
              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-3 border-b border-slate-200 dark:border-slate-700">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (ii)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.poa_attach}
                    onChange={(e) =>
                      CompliancehandleChange("poa_attach", e.target.checked)
                    }
                  />
                  Attached
                </label>
              </div>

              {/* Alert Email */}
              <div className="grid grid-cols-1 md:grid-cols-[40px_200px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-red-600">(iii)</div>
                <div className="font-semibold text-red-600">
                  Alert Email Address
                </div>
                <input
                  type="text"
                  placeholder="Enter alert email"
                  className="w-full rounded border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-sm px-2 py-1 focus:outline-none focus:ring-1 focus:ring-green-600"
                  value={complianceData.poaalertemail}
                  onChange={(e) =>
                    CompliancehandleChange("poaalertemail", e.target.value)
                  }
                />
              </div>
            </div>

            {/* ===== POA Foreign Certificate ===== */}
            <div className="rounded-md border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 mb-4">
              <div className="flex gap-2 px-4 py-2 border-b border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (d)
                </div>
                <div className="text-slate-700 dark:text-slate-200 font-semibold">
                  POA – <strong>Foreign Certificate</strong>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (i)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.poa_Foreign_Certificate_Attach}
                    onChange={(e) =>
                      CompliancehandleChange(
                        "poa_Foreign_Certificate_Attach",
                        e.target.checked,
                      )
                    }
                  />
                  Attached
                </label>
              </div>
            </div>

            {/* ===== WAIVER OF SENDING DOCUMENTS ===== */}
            <div className="rounded-md border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 mb-4">
              <div className="flex gap-2 px-4 py-2 border-b border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (e)
                </div>
                <div className="text-slate-700 dark:text-slate-200 font-semibold">
                  Waiver of sending documents on file
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-3 border-b border-slate-200 dark:border-slate-700">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (i)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.waiverOfSendingDocuments_Attach}
                    onChange={(e) =>
                      CompliancehandleChange(
                        "waiverOfSendingDocuments_Attach",
                        e.target.checked,
                      )
                    }
                  />
                  Attached
                </label>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_200px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (ii)
                </div>
                <div className="font-semibold text-slate-700 dark:text-slate-200">
                  Waiver Company
                </div>
                <input
                  type="text"
                  placeholder="Enter Waiver Company"
                  className="w-full rounded border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-sm px-2 py-1 focus:outline-none focus:ring-1 focus:ring-green-600"
                  value={complianceData.coLoadAgreementOnFile}
                  onChange={(e) =>
                    CompliancehandleChange(
                      "coLoadAgreementOnFile",
                      e.target.value,
                    )
                  }
                />
              </div>
            </div>

            {/* ===== Co-Load Agreement ===== */}
            <div className="rounded-md border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 mb-4">
              <div className="flex gap-2 px-4 py-2 border-b border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (f)
                </div>
                <div className="text-slate-700 dark:text-slate-200 font-semibold">
                  Co-Load Agreement
                </div>
              </div>

              {/* (i) Date Sent */}
              <div className="grid grid-cols-1 md:grid-cols-[40px_200px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (i)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    className="accent-green-600"
                    type="checkbox"
                    checked={complianceData.coload_date_check}
                    onChange={(e) =>
                      CompliancehandleChange(
                        "coload_date_check",
                        e.target.checked,
                      )
                    }
                  />
                  Date Sent
                </label>
                <input
                  type="date"
                  className="w-32 rounded border border-slate-300 dark:border-slate-600
        bg-white dark:bg-slate-800
        text-slate-800 dark:text-slate-100
        text-sm px-2 py-1
        focus:outline-none focus:ring-1 focus:ring-green-600"
                  value={complianceData.coload_dateSent}
                  onChange={(e) =>
                    CompliancehandleChange("coload_dateSent", e.target.value)
                  }
                />
              </div>

              {/* (ii) Attached */}
              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (ii)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.coload_Attach}
                    onChange={(e) =>
                      CompliancehandleChange("coload_Attach", e.target.checked)
                    }
                  />
                  Attached
                </label>
              </div>
            </div>

            {/* ===== Vendor Approval Process Complete ===== */}
            <div className="rounded-md border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 mb-4">
              <div className="flex gap-2 px-4 py-2 border-b border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (g)
                </div>
                <div className="text-slate-700 dark:text-slate-200 font-semibold">
                  Vendor Approval Design System for 24 month renewal cycle. Tie
                  to A/P to prevent payments without vendor approval on file.
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_200px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (i)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.vend_Approved}
                    onChange={(e) =>
                      CompliancehandleChange("vend_Approved", e.target.checked)
                    }
                  />
                  Date Approved
                </label>
                <input
                  type="date"
                  className="w-32 rounded border border-slate-300 dark:border-slate-600
        bg-white dark:bg-slate-800
        text-slate-800 dark:text-slate-100
        text-sm px-2 py-1
        focus:outline-none focus:ring-1 focus:ring-green-600"
                  value={complianceData.vend_Date_Approved}
                  onChange={(e) =>
                    CompliancehandleChange("vend_Date_Approved", e.target.value)
                  }
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (ii)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.vend_Attach}
                    onChange={(e) =>
                      CompliancehandleChange("vend_Attach", e.target.checked)
                    }
                  />
                  Attached
                </label>
              </div>
            </div>

            {/* ===== C-TPAT Certification ===== */}
            <div className="rounded-md border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 mb-4">
              <div className="flex gap-2 px-4 py-2 border-b border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (h)
                </div>
                <div className="text-slate-700 dark:text-slate-200 font-semibold">
                  C-TPAT Certification Design System for 18 month renewal cycle.
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_200px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (i)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.ctpat_confirmed}
                    onChange={(e) =>
                      CompliancehandleChange(
                        "ctpat_confirmed",
                        e.target.checked,
                      )
                    }
                  />
                  Date Confirmed
                </label>
                <input
                  type="date"
                  className="w-32 rounded border border-slate-300 dark:border-slate-600
        bg-white dark:bg-slate-800
        text-slate-800 dark:text-slate-100
        text-sm px-2 py-1
        focus:outline-none focus:ring-1 focus:ring-green-600"
                  value={complianceData.ctpat_dateconfirmed}
                  onChange={(e) =>
                    CompliancehandleChange(
                      "ctpat_dateconfirmed",
                      e.target.value,
                    )
                  }
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (ii)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.ctpat_attach}
                    onChange={(e) =>
                      CompliancehandleChange("ctpat_attach", e.target.checked)
                    }
                  />
                  Attached
                </label>
              </div>
            </div>

            {/* ===== Agent Agreements ===== */}
            <div className="rounded-md border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 mb-4">
              <div className="flex gap-2 px-4 py-2 border-b border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (i)
                </div>
                <div className="text-slate-700 dark:text-slate-200 font-semibold">
                  Agent Agreements Design System for 24 month renewal cycle. Tie
                  to A/P to prevent payments without agreement on file.
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (i)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.agent_corrupt}
                    onChange={(e) =>
                      CompliancehandleChange("agent_corrupt", e.target.checked)
                    }
                  />
                  Logistics Representative Certification/Acknowledgement of
                  Foreign Corrupt Practices Act Policy.
                </label>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (ii)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.agent_due}
                    onChange={(e) =>
                      CompliancehandleChange("agent_due", e.target.checked)
                    }
                  />
                  Agent Due Diligence For Business Partners.
                </label>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (iii)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.agent_attach}
                    onChange={(e) =>
                      CompliancehandleChange("agent_attach", e.target.checked)
                    }
                  />
                  Attached
                </label>
              </div>
            </div>

            {/* ===== Air Freight ===== */}
            <div className="rounded-md border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 mb-4">
              <div className="flex gap-2 px-4 py-2 border-b border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (j)
                </div>
                <div className="text-slate-700 dark:text-slate-200 font-semibold">
                  Air Freight
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (i)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.knownshipper}
                    onChange={(e) =>
                      CompliancehandleChange("knownshipper", e.target.checked)
                    }
                  />
                  Known Shipper
                </label>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (ii)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.unknownshipper}
                    onChange={(e) =>
                      CompliancehandleChange("unknownshipper", e.target.checked)
                    }
                  />
                  Unknown Shipper
                </label>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (iii)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.airattach}
                    onChange={(e) =>
                      CompliancehandleChange("airattach", e.target.checked)
                    }
                  />
                  Attached
                </label>
              </div>
            </div>

            {/* ===== Credit Agreement ===== */}
            <div className="rounded-md border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 mb-4">
              <div className="flex gap-2 px-4 py-2 border-b border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (k)
                </div>
                <div className="text-slate-700 dark:text-slate-200 font-semibold">
                  Credit Agreement
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_200px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (i)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.creditAgreement}
                    onChange={(e) =>
                      CompliancehandleChange(
                        "creditAgreement",
                        e.target.checked,
                      )
                    }
                  />
                  Agreement Date
                </label>
                <input
                  type="date"
                  className="w-32 rounded border border-slate-300 dark:border-slate-600
        bg-white dark:bg-slate-800
        text-slate-800 dark:text-slate-100
        text-sm px-2 py-1
        focus:outline-none focus:ring-1 focus:ring-green-600"
                  value={complianceData.creditAgreementDate}
                  onChange={(e) =>
                    CompliancehandleChange(
                      "creditAgreementDate",
                      e.target.value,
                    )
                  }
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (ii)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.creditAgreementAttach}
                    onChange={(e) =>
                      CompliancehandleChange(
                        "creditAgreementAttach",
                        e.target.checked,
                      )
                    }
                  />
                  Attached
                </label>
              </div>
            </div>

            {/* ===== LOI ===== */}
            <div className="rounded-md border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 mb-4">
              <div className="flex gap-2 px-4 py-2 border-b border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (l)
                </div>
                <div className="text-slate-700 dark:text-slate-200 font-semibold">
                  LOI
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_200px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (i)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.loi}
                    onChange={(e) =>
                      CompliancehandleChange("loi", e.target.checked)
                    }
                  />
                  Date
                </label>
                <input
                  type="date"
                  className="w-32 rounded border border-slate-300 dark:border-slate-600
        bg-white dark:bg-slate-800
        text-slate-800 dark:text-slate-100
        text-sm px-2 py-1
        focus:outline-none focus:ring-1 focus:ring-green-600"
                  value={complianceData.loiDate}
                  onChange={(e) =>
                    CompliancehandleChange("loiDate", e.target.value)
                  }
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-[40px_1fr] gap-2 px-4 py-3">
                <div className="font-semibold text-slate-600 dark:text-slate-300">
                  (ii)
                </div>
                <label className="flex items-center gap-2 text-slate-700 dark:text-slate-200">
                  <input
                    type="checkbox"
                    className="accent-green-600"
                    checked={complianceData.loiAgreementAttach}
                    onChange={(e) =>
                      CompliancehandleChange(
                        "loiAgreementAttach",
                        e.target.checked,
                      )
                    }
                  />
                  Attached
                </label>
              </div>
            </div>

            {/* ===== SAVE BUTTON ===== */}
            <div className="row mt-4">
              <div className="col-md-12 text-center">
                <CelebrationButton
                  onClick={() => CompliancehandleSubmit()}
                  label={" Save / Update"}
                  className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-md text-sm font-medium transition-all"
                  icon={<></>}
                  isSuccess={isAnimate}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ComplianceCertificationSection;
